import { normalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import { catchError, mergeMap, map } from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { documentsOrFoldersSchema } from '../../store/schema';
import { fetchFeedSuccess } from './actions';
import { entitiesFetchSuccess } from '../../store/entities/actions';


const fetch = (action$) => action$.pipe(
  ofType(actionTypes.FETCH),
  mergeMap((action) => api.feeds.fetchBySpaceId(action.spaceId).pipe(
    map((response) => normalize(response.body, documentsOrFoldersSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchFeedSuccess(action.spaceId, result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


export default combineEpics(fetch);
